<template>
  <div class="InputFields">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {},
}
</script>

<style scoped>
.InputFields {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-7);
  max-width: 34rem;
}
</style>
